export interface IOrganizationSettings {
    genAI: { enabled: boolean };
    developer?: { enabled: boolean; vendorName: string };
}

export class OrganizationSettings implements IOrganizationSettings {
    genAI: { enabled: boolean };
    developer?: { enabled: boolean; vendorName: string };

    constructor({ Settings }: { Settings: IOrganizationSettings }) {
        this.genAI = Settings.genAI;
        this.developer = Settings.developer;
    }
}
